import React, { Component, Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import Ingredient from '~/containers/ingredient/ingredient';
import AdjustIngredientAmountOnHandModal from '~/containers/adjustIngredientAmountOnHandModal/adjustIngredientAmountOnHandModal';

export class IngredientPage extends Component {
  state = {
    adjustAmountModalOpen: false,
    ingredient: null
  };

  onReceiveIngredient = ({ ingredient }) => {
    this.setState({
      ingredient
    });
  };

  toggleAdjustAmount = () => {
    this.setState({
      adjustAmountModalOpen: !this.state.adjustAmountModalOpen
    });
  };

  render() {
    const ingredientId = this.props.match.params.ingredientId;
    const { ingredient, adjustAmountModalOpen } = this.state;

    const buttons = (
      <Fragment>
        {ingredient &&
          ingredient.isTracked && (
            <Button className="mr3" color="secondary" onClick={this.toggleAdjustAmount}>
              Adjust stock level
            </Button>
          )}
        <Link to={`/ingredients/${ingredientId}/edit`}>
          <Button data-qa="ingredient-edit" color="primary">
            Edit
          </Button>
        </Link>
      </Fragment>
    );

    return (
      <Page>
        <TitleBar
          back="/ingredients"
          backText="Ingredients"
          title={ingredient ? ingredient.name : '...'}
          button={buttons}
        />
        <Ingredient onCompleted={this.onReceiveIngredient} id={ingredientId} />
        {ingredient &&
          ingredient.isTracked && (
            <AdjustIngredientAmountOnHandModal
              ingredient={ingredient}
              isOpen={adjustAmountModalOpen}
              onSuccess={this.toggleAdjustAmount}
              onToggle={this.toggleAdjustAmount}
            />
          )}
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(IngredientPage));



// WEBPACK FOOTER //
// ./src/pages/ingredient/ingredient.jsx